import { UsersInStoreTableProps } from './users-in-store-table.types'
import {
  PaginationButtons,
  TableBodyContainer,
  TableContainer,
  TableHeader
} from '@touche-lts/panel-ui/dist'
import { usersInStoreTableWidths } from './users-in-shop-table.utils'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { UsersInShopTableBodyLine } from './users-in-shop-table-body-line'
import { UsersInStoreTableSortProps } from 'mobx-stores'
import { useGetScrollWidth } from 'hooks/custom-hooks'
import styles from './users-in-store-table.module.scss'
import cl from 'classnames'

const UsersInStoreTableComponent = (props: UsersInStoreTableProps) => {
  const { className, style, users = [], onRemoveUserClick } = props
  const {
    usersInStoreTableStore: {
      setUsers,
      triggerSearch,
      clearStore,
      searchResults,
      isColumnMarked,
      handleSortDirectionChange,
      getSortDirection,
      paginationInfo,
      onSearchPropsChange,
      searchProps
    },
    generalStore: { loadUserRoles, userRoleSelectOptions }
  } = useRootStore()

  useEffect(() => {
    setUsers(users)
    triggerSearch({ resetPageNumber: true })
  }, [users, setUsers, triggerSearch])
  useEffect(() => {
    loadUserRoles()
    return clearStore
  }, [loadUserRoles, clearStore])

  const {scrollX,handleScroll} = useGetScrollWidth()

  return (
    <TableContainer
      noBoxShadow
      className={cl(className,styles.thinScroll)}
      style={{ marginTop: 22, minHeight: 550, ...style, overflowX: 'auto' }}
      onScroll={handleScroll}
    >
      <TableHeader
        tableColumns={[
          {
            label: 'users',
            widthPx: usersInStoreTableWidths.user,
            sortDirection: getSortDirection(UsersInStoreTableSortProps.NAME),
            isColumnMarked: isColumnMarked(UsersInStoreTableSortProps.NAME),
            setSortDirection: handleSortDirectionChange(
              UsersInStoreTableSortProps.NAME
            ),
            inputProps: {
              placeholder: 'Search...',
              value: searchProps.name,
              onChange: name => onSearchPropsChange({ name })
            }
          },
          {
            label: 'role',
            widthPx: usersInStoreTableWidths.role,
            sortDirection: getSortDirection(UsersInStoreTableSortProps.ROLE),
            isColumnMarked: isColumnMarked(UsersInStoreTableSortProps.ROLE),
            setSortDirection: handleSortDirectionChange(
              UsersInStoreTableSortProps.ROLE
            ),
            selectProps: {
              options: userRoleSelectOptions,
              noneLabel: 'All',
              onChange: role => onSearchPropsChange({ role }),
              value: searchProps.role
            }
          },
          {
            label: 'added to store',
            sortDirection: getSortDirection(UsersInStoreTableSortProps.DATE),
            isColumnMarked: isColumnMarked(UsersInStoreTableSortProps.DATE),
            setSortDirection: handleSortDirectionChange(
              UsersInStoreTableSortProps.DATE
            ),
            periodFilterProps: {
              period: searchProps.addedOnPeriod,
              setPeriod: addedOnPeriod => onSearchPropsChange({ addedOnPeriod })
            },
            widthPx: usersInStoreTableWidths.assignStore,
          }
        ]}
      />
      <TableBodyContainer className={styles.tableBodyContainer}>
        {searchResults.map(user => {
          return (
            <UsersInShopTableBodyLine
              key={user.id}
              user={user}
              onRemoveClick={() => onRemoveUserClick(user)}
              className={styles.tableBodyLine}
            />
          )
        })}
      </TableBodyContainer>
      <PaginationButtons {...paginationInfo} alwaysShow style={{width : scrollX}} />
    </TableContainer>
  )
}

const UsersInStoreTable = observer(UsersInStoreTableComponent)
export { UsersInStoreTable }
